export default __webpack_public_path__ + "static/media/Jit.4f7aa5a9.svg";